import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface selectState {
    selectedClass: string | undefined;
    firstRender: boolean;
}

const initialState: selectState = {
    selectedClass: undefined,
    firstRender: true,
};

const selectSlice = createSlice({
    name: 'librarySelect',
    initialState,
    reducers: {
        setSelectedClass(state, action: PayloadAction<string>) {
            state.selectedClass = action.payload;
        },
        setFirstRender(state, action: PayloadAction<boolean>) {
            state.firstRender = action.payload;
        },
    },
});

export const { setSelectedClass, setFirstRender } = selectSlice.actions;
export default selectSlice.reducer;
